import uploadFileWithFormData from './uploadFileWithFormData';

export default function uploadPdfBlobWithFileNameAndOpts (
  pdfBlob: Blob,
  fileName: string,
  opts: {
    container?: string;
    folderPath?: string;
  },
) {
  const formData = new FormData();
  const file = new File([pdfBlob], fileName);
  formData.append('file', file);
  formData.append('containerName', opts.container);
  formData.append('folderPath', opts.folderPath);
  return uploadFileWithFormData(formData, 'application/pdf');
}
